import type { IFetchService } from "app/services/fetchService";
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { CrmList } from "../../types";

export type CrmListsApiService = { fetchCrmLists(): Promise<CrmList[]> };

export const createCrmListsApiService = (fetchService: IFetchService): CrmListsApiService => ({
    fetchCrmLists: createCancelable((cancellation: AbortSignal) => {
        return fetchService.get<CrmList[]>("/sales-api/crm-integration/lists", null, {
            cancellation,
        });
    }),
});
